const getParameterByName = (name) => {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    const regex = new RegExp(`[\\?&]${name}=([^&#]*)`);
    const results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

const setCookie = (name, value, days) => {
    let expires = '';
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = `; expires=${date.toUTCString()}`;
    }
    document.cookie = `${name}=${value}${expires}; path=/; Secure; SameSite=None`;
};

const setLocalStorage = (name, value) => {
    if (value) {
        localStorage.setItem(name, value);
    }
};

const checkAndStoreUTMParameters = () => {
    const utm_source = getParameterByName('utm_source');
    const utm_medium = getParameterByName('utm_medium');
    const utm_campaign = getParameterByName('utm_campaign');
    const utm_term = getParameterByName('utm_term');
    const utm_content = getParameterByName('utm_content');

    if (utm_source) {
        setCookie('utm_source', utm_source, 30);
        setLocalStorage('utm_source', utm_source);
    }
    if (utm_medium) {
        setCookie('utm_medium', utm_medium, 30);
        setLocalStorage('utm_medium', utm_medium);
    }
    if (utm_campaign) {
        setCookie('utm_campaign', utm_campaign, 30);
        setLocalStorage('utm_campaign', utm_campaign);
    }
    if (utm_term) {
        setCookie('utm_term', utm_term, 30);
        setLocalStorage('utm_term', utm_term);
    }
    if (utm_content) {
        setCookie('utm_content', utm_content, 30);
        setLocalStorage('utm_content', utm_content);
    }
};

document.addEventListener('DOMContentLoaded', () => {
    checkAndStoreUTMParameters();
});
